import type { PickFolderSuggestionView } from "./types";

export const pickFolderSuggestionView: PickFolderSuggestionView = ({
  suggestion,
  isSuggesting,
  suggestError,
}) => {
  if (isSuggesting) return { view: "status", variant: "loading" };
  // A failed "Suggest again" keeps the last result on screen; the steps show the error above it.
  if (suggestion !== null && suggestion.dimensions.length > 0) {
    return { view: "steps", suggestion };
  }
  if (suggestError !== null) return { view: "status", variant: suggestError };
  // No result yet: the request starts as the modal opens.
  if (suggestion === null) return { view: "status", variant: "loading" };
  return { view: "status", variant: "empty" };
};
